import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class OverriddingRiskModal extends Component {
    constructor() {
        super()
        this.state = {
            overriddingRiskFactorCreatedFlag: false,
            modalType: '',
            overriddingRiskFactorErrorFlag: false,
            overiddingRiskFactorErrorMessage: ''
        }
    }
    componentDidUpdate(prevProps) {
        const { createOverriddingRiskFactorSuccess, createOverriddingRiskFactorFailure, editOverriddingRiskFactorSuccess, editOverriddingRiskFactorFailure } = this.props
        if (editOverriddingRiskFactorSuccess !== prevProps.editOverriddingRiskFactorSuccess) {
            if (editOverriddingRiskFactorSuccess.status === 200) {
                this.setState({
                    modalType: 'Edited',
                    overriddingRiskFactorCreatedFlag: true
                })
            }
        }
        if (createOverriddingRiskFactorSuccess !== prevProps.createOverriddingRiskFactorSuccess) {
            if (createOverriddingRiskFactorSuccess.status === 200) {
                this.setState({
                    modalType: 'Created',
                    overriddingRiskFactorCreatedFlag: true
                })
            }
        }
        if (createOverriddingRiskFactorFailure !== prevProps.createOverriddingRiskFactorFailure || editOverriddingRiskFactorFailure !== prevProps.editOverriddingRiskFactorFailure) {
            if (createOverriddingRiskFactorFailure) {
                this.setState({
                    overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag,
                    uploadModalErrorMessage: (this.props.createOverriddingRiskFactorFailure.response && this.props.createOverriddingRiskFactorFailure.response.data) ? this.props.createOverriddingRiskFactorFailure.response.data.message : "Something went wrong! Please try again."
                })
            } else if (editOverriddingRiskFactorFailure) {
                this.setState({
                    overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag,
                    uploadModalErrorMessage: (this.props.editOverriddingRiskFactorFailure.response && this.props.editOverriddingRiskFactorFailure.response.data) ? this.props.editOverriddingRiskFactorFailure.response.data.message : "Something went wrong! Please try again."
                })
            }
        }
    }
    toggle = () => {
        this.setState({ overriddingRiskFactorCreatedFlag: !this.state.overriddingRiskFactorCreatedFlag })
    }
    errorclose = () => {
        this.setState({ overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag })
    }
    redirectView = () => {
        this.props.modalCallBack();
    }
    render() {
        return (
            <div>
                <Modal isOpen={this.state.overriddingRiskFactorCreatedFlag} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                    <ModalBody>
                        Overridng Risk Factor Successfully {this.state.modalType}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                        <Button color="info" onClick={this.redirectView}>View</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.overriddingRiskFactorErrorFlag} toggle={this.errorclose} className={this.props.className}>
                    <ModalHeader toggle={this.errorclose}>Error</ModalHeader>
                    <ModalBody>
                        {this.state.overiddingRiskFactorErrorMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.errorclose}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    createOverriddingRiskFactorSuccess: state.overriddingRiskFactor.createOverriddingRiskFactorSuccess,
    createOverriddingRiskFactorFailure: state.overriddingRiskFactor.createOverriddingRiskFactorFailure,
    editOverriddingRiskFactorSuccess: state.overriddingRiskFactor.editSuccess,
    editOverriddingRiskFactorFailure: state.overriddingRiskFactor.editFailed
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OverriddingRiskModal);